import { Component } from '@angular/core';

@Component({
  selector: 'app-loader',
  standalone: false,
  templateUrl: './app-loader.component.html',
  styleUrl: './app-loader.component.scss'
})
export class AppLoaderComponent {

}
